module.exports = __webpack_public_path__ + "img/uploading.4d415bb5.gif";